export const RECEPTION_IP_EXTRA_CHROME = { desktop: 40, mobile: 48 };

export const getReceptionTableScroll = ({
  isMobile = false,
  extraChrome = 0,
} = {}) => {
  const baseOffset = isMobile ? 300 : 240;
  return {
    y: `calc(100vh - ${baseOffset + extraChrome}px)`,
    x: "max-content",
  };
};

export const getInpatientTableScroll = (isMobile) =>
  getReceptionTableScroll({
    isMobile,
    extraChrome: isMobile
      ? RECEPTION_IP_EXTRA_CHROME.mobile
      : RECEPTION_IP_EXTRA_CHROME.desktop,
  });
